// extracted by mini-css-extract-plugin
module.exports = {"fullHeightContainer":"HomePageSeedComponent_fullHeightContainer__15Ptt","flexRow":"HomePageSeedComponent_flexRow__1YP0_","staticRow":"HomePageSeedComponent_staticRow__jG51q"};